// removed by extract-text-webpack-plugin
module.exports = {"Loader":"_3I4EeI1SaZj_Xpu8SUkxkV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/styles.css
// module id = 607
// module chunks = 0